import React from "react";
import * as R from "ramda";
import { QuestionOutlined } from "@ant-design/icons";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import {
  message,
  Row,
  Col,
  Input,
  Button,
  notification,
  Radio,
  Select
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { connect } from "react-redux";
import { startEditCheck } from "../actions/checks";
import { startSetLabelsData } from "../actions/auth";
import {
  formatPeriodRev,
  formatPeriod,
  formatUrl,
  filterByName,
  formatProbersOptions,
  objToArrOfObj,
  mergeAll,
  trimNum,
  formatAlertToArr
} from "./functions/checkFormFuncs";
import {
  apdexOptions,
  periodOptions,
  httpMethodOptions,
  dnsQueryTypeOptions
} from "./consts/formOptions";
import {
  checkProbersViolation,
  checkProtocolViolation,
  checkMethodViolation
} from "../utils/checkActivePlanViolations";
import JsonInput from "./JsonInput";
import SelectDD from "./SelectDD";
import PopUp from "./PopUp";
import PlansPopUp from "./PlansPopUp";
import HelpCenter from "./HelpCneter";
import Logo from "../assets/images/up-logo.svg";
import "../styles/components/check-form.scss";

const { Option } = Select;
class EditMonitor extends React.Component {
  constructor(props) {
    super(props);

    const monitor = this.props.monitor;

    this.state = {
      url: monitor.target,
      host: monitor.target,
      alias: monitor.alias,
      period: formatPeriod(monitor.period),
      apdex: `${monitor.apdex} sec`,
      protocol_type: monitor.protocol_type,
      http_method: monitor.http_method,
      probers: R.map(R.prop("name"), monitor.probers),
      alert: formatAlertToArr(monitor.alert),
      http_headers: !R.isEmpty(monitor.http_headers) && monitor.http_headers !== null
        ? objToArrOfObj(monitor.http_headers)
        : [{}],
      http_body: monitor.http_body,
      isPlansOpen: false,
      showNotification: false,
      periodOptions: periodOptions,
      proberOptions: this.props.probers,
      visible: false,
      componentName: "apdex",
      is_enabled: monitor.is_enabled,
      dns_query_type: monitor.dns_query_type,
      dns_query_name: monitor.dns_query_name,
      labels: monitor.labels
    };
  }

  onMonitoringChanged = () => {
    if (!this.props.monitor.is_protected)
      this.setState({ is_enabled: !this.state.is_enabled });
    else {
      this.showNotif(
        "Protected Monitor",
        "You can't change protected monitor status",
        true
      );
    }
  };

  showDrawer = componentName => {
    this.setState({
      visible: true,
      componentName: componentName
    });
  };

  onClose = () => {
    this.setState({
      visible: false
    });
  };

  onChange = e => {
    const val = e.target.value;
    const name = e.target.name;
    this.setState(prevState => ({ [name]: val, host: prevState.url }));
  };

  onSubmit = e => {
    e.preventDefault();
    this.sendData();
  };

  formatData = () => {
    const protocol = this.state.protocol_type;
    const isBaseProtocol = protocol === "HTTP(S)";
    const isDns = protocol === "DNS";

    const propIsNotEmpty = R.propSatisfies(R.complement(R.isEmpty));
    const isValid = R.allPass([
      propIsNotEmpty("period"),
      propIsNotEmpty("apdex"),
      propIsNotEmpty("probers")
    ]);

    if (!isValid(this.state)) {
      this.setState(() => ({
        error: "Please fill all fields."
      }));
      message.warning("Please fill all fields.");
      return;
    }

    const transformations = {
      url: formatUrl(R.__, protocol),
      host: formatUrl(R.__, protocol),
      period: formatPeriodRev,
      apdex: trimNum(R.__, 0, 4),
      http_headers: mergeAll
    };
    const formatData = R.evolve(transformations);
    let monitor = formatData(this.state);

    const filterData = receiver =>
      R.includes(R.prop("value", receiver), this.state.alert);
    const formatAlertData = value =>
      R.map(R.prop("value"), R.filter(filterData, value));
    const formatAlerts = R.mapObjIndexed(formatAlertData);

    const probers = filterByName(this.props.probers, this.state.probers);
    const alerts = formatAlerts(this.props.alerts);
    monitor = R.assoc("probers", probers, monitor);
    monitor = R.assoc("alert", alerts, monitor);
    monitor = R.assoc("id", this.props.monitor.id, monitor);

    const dnsKeys = isDns
      ? ["http_headers", "http_method"]
      : ["dns_query_name", "dns_query_type"];
    let keysToOmitByProtocol = isBaseProtocol ? ["host"] : ["url"]; // TODO: rewrite with ramda
    keysToOmitByProtocol = R.concat(keysToOmitByProtocol, [
      "isPlansOpen",
      "showNotification",
      "periodOptions",
      "visible",
      "componentName",
      ...dnsKeys
    ]);
    monitor = R.omit(keysToOmitByProtocol, monitor);

    const labels = this.props.labels;
    this.state.labels.forEach(el => {
      if (!labels.includes(el)) {
        labels.push(el);
        this.props.startSetLabelsData(labels);
      }
    });

    this.props.startEditCheck(monitor);
    this.props.closePopUp();
  };

  sendData = () => {
    this.setState(
      prevState => ({
        host: prevState.url
      }),
      this.formatData
    );
  };

  headerAdd = () => {
    this.setState(prevState => {
      const temp = prevState.http_headers;
      temp.push({});
      return {
        http_headers: temp
      };
    });
  };

  headerRemove = index => {
    this.setState(prevState => {
      const temp = prevState.http_headers;
      temp.splice(index, 1);
      return {
        http_headers: temp
      };
    });
  };

  changeHeaderValue = (obj, index) => {
    this.setState(prevState => {
      const temp = prevState.http_headers;
      temp.splice(index, 1, obj);
      return {
        http_headers: temp
      };
    });
  };

  showNotif = (title, text, noButton) => {
    let key = "1";
    const btn = (
      <Button
        onClick={() => {
          notification.close(key);
          this.setState({ isPlansOpen: true });
        }}
        type="primary"
        size="small"
      >
        Upgrade Plan
      </Button>
    );
    notification.config({
      duration: 10,
      placement: "bottomLeft"
    });
    const args = {
      message: title,
      description: text,
      btn: noButton ? undefined : btn,
      key
    };
    notification.warn(args);
  };

  checkPeriodSelection = (period, subscriptions) => {
    let intPeriod = period;
    if (period.includes("min")) {
      intPeriod = parseInt(period.replace(/\D+/g, "")) * 60;
    } else if (period.includes("sec")) {
      intPeriod = parseInt(period.replace(/\D+/g, ""));
    }
    if (intPeriod < subscriptions.MINIMUM_MONITOR_PERIOD) {
      this.showNotif(
        `${this.props.plan_name} Plan`,
        `You can't select fewer than ${formatPeriod(
          subscriptions.MINIMUM_MONITOR_PERIOD
        )}`
      );
      this.getPeriodOptions(true);
      return false;
    }
    return true;
  };

  checkProberSelection = (prober, subscriptions, dataObj) => {
    const activePlanProbers = R.prop("PROBERS", subscriptions);
    let isViolated = false;
    if (activePlanProbers) {
      const selectableProbers = R.map(
        R.prop("value"),
        R.filter(
          el => R.includes(R.prop("id", el), activePlanProbers),
          R.flatten(R.values(dataObj))
        )
      );
      isViolated = checkProbersViolation(prober, selectableProbers);
    }

    if (isViolated) {
      this.showNotif(
        `${this.props.plan_name} Plan`,
        "Enabled probers can only be selected."
      );
      this.getProberOptions(true);
      return false;
    }

    return true;
  };

  checkProtocolViolation = (protocol, subscriptions) => {
    const activePlanProtocols = R.keys(subscriptions.PROTOCOL);
    const swapHttpWithHttps = R.map(
      el => (el === "HTTP" ? "HTTP(S)" : el),
      activePlanProtocols
    );
    const isViolated = checkProtocolViolation(protocol, swapHttpWithHttps);
    if (isViolated) {
      this.showNotif(
        `${this.props.plan_name} Plan`,
        "Enabled protocols can only be selected."
      );
      return false;
    }
    return true;
  };

  checkMethodViolation = (method, subscriptions) => {
    const activePlanMethods = R.path(
      ["PROTOCOL", "HTTP", "AVAILABLE_METHODS"],
      subscriptions
    );
    const isViolated = checkMethodViolation(method, activePlanMethods);
    if (isViolated) {
      this.showNotif(
        `${this.props.plan_name} Plan`,
        "Enabled methods can only be selected."
      );
      return false;
    }
    return true;
  };

  openPlans = () => {
    this.setState({
      isPlansOpen: true
    });
  };

  closePlans = () => {
    this.setState({
      isPlansOpen: false
    });
  };

  getPeriodOptions(mustDisable) {
    const checkLimit = period => {
      let intPeriod = period.value;
      if (period.value.includes("sec")) {
        intPeriod = parseInt(period.value.replace(/\D+/g, ""));
        if (intPeriod < this.props.subscriptions.MINIMUM_MONITOR_PERIOD) {
          period["disabled"] = true;
        }
      } else if (period.value.includes("min")) {
        intPeriod = parseInt(period.value.replace(/\D+/g, "")) * 60;
        if (intPeriod < this.props.subscriptions.MINIMUM_MONITOR_PERIOD) {
          period["disabled"] = true;
        }
      }
      return period;
    };

    if (this.state.showNotification || mustDisable) {
      let newPeriodOptions = R.clone(periodOptions);
      R.map(checkLimit, newPeriodOptions);
      this.setState({ periodOptions: newPeriodOptions });
    } else {
      this.setState({ periodOptions: periodOptions });
    }
  }

  getProberOptions(mustDisable) {
    const checkLimit = prober => {
      let isLimit = false;
      for (var id of this.props.subscriptions.PROBERS) {
        if (prober.id !== id) {
          isLimit = true;
        } else {
          isLimit = false;
          break;
        }
      }
      if (isLimit) {
        prober["disabled"] = true;
      }
      return prober;
    };

    if (this.state.showNotification || mustDisable) {
      let newProberOptions = R.clone(this.props.probers);
      R.map(checkLimit, newProberOptions);
      this.setState({ proberOptions: newProberOptions });
    } else {
      this.setState({ proberOptions: this.props.probers });
    }
  }

  onBodyChange = e => {
    const value = e.target.value;
    this.setState({ http_body: value });
  };

  handleChange = labels => {
    this.setState({ labels });
  };

  render() {
    const hasGroup = this.props.subscriptions
      ? R.has("MONITOR_GROUP", this.props.subscriptions)
      : false;
    const isMobile = window.innerWidth < 576;
    const protocol = this.state.protocol_type;
    const isBaseProtocol = protocol === "HTTP(S)";
    const isDns = protocol === "DNS";

    return (
      <div className="check-form-body">
        <img src={Logo} alt="logo" />
        <Form className="check-form" onSubmit={this.onSubmit}>
          <Row gutter={32} className="text-input">
            <Col span={24}>
              <div className="check-form__title">
                <h2>Edit Monitor</h2>
                <p>Enter your details below</p>
              </div>
            </Col>
            <Col span={24}>
              <Row gutter={32}>
                <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                  <label htmlFor="monitoring">Monitoring</label>
                  <div>
                    <Radio.Group
                      value={this.state.is_enabled ? "enable" : "disable"}
                      buttonStyle="solid"
                      onChange={this.onMonitoringChanged}
                    >
                      <Radio.Button value="enable">Enable</Radio.Button>
                      <Radio.Button value="disable">Disable</Radio.Button>
                    </Radio.Group>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={32}>
                <Col
                  xxl={isBaseProtocol ? 20 : 24}
                  xl={isBaseProtocol ? 20 : 24}
                  lg={isBaseProtocol ? 20 : 24}
                  md={isBaseProtocol ? 20 : 24}
                  sm={24}
                  xs={24}
                >
                  <label htmlFor="target">Address</label>
                  <SelectDD
                    value={protocol}
                    style={{ width: "90px", display: "inline-block" }}
                    disabled={true}
                    checkAuthority={this.checkProtocolViolation}
                    subscriptions={this.props.subscriptions}
                  />
                  <Input
                    type="text"
                    name="target"
                    id="target"
                    value={this.state.url}
                    className="address-input"
                    disabled
                  />
                </Col>
                {isBaseProtocol && (
                  <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
                    <label htmlFor="method">Method</label>
                    <SelectDD
                      id="method"
                      name="method"
                      data={httpMethodOptions}
                      value={this.state.http_method}
                      onSelect={http_method => this.setState({ http_method })}
                      style={{ width: "100%" }}
                      checkAuthority={this.checkMethodViolation}
                      subscriptions={this.props.subscriptions}
                    />
                  </Col>
                )}
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={32}>
                <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                  <label htmlFor="alias">Name (optional)</label>
                  <Input
                    htmlFor="alias"
                    type="text"
                    id="alias"
                    name="alias"
                    placeholder="Website"
                    value={this.state.alias}
                    onChange={this.onChange}
                  />
                </Col>

                <Col xxl={6} xl={6} md={6} sm={12} xs={12}>
                  <label htmlFor="time_interval">Time interval</label>
                  <SelectDD
                    id="time_interval"
                    name="time_interval"
                    data={this.state.periodOptions}
                    value={this.state.period}
                    onSelect={period => {
                      this.setState({ period });
                    }}
                    checkAuthority={this.checkPeriodSelection}
                    subscriptions={this.props.subscriptions}
                    style={{ width: "100%" }}
                  />
                </Col>
                <Col xxl={6} xl={6} md={6} sm={12} xs={12}>
                  <label htmlFor="apdex">
                    Expected time
                    <Button
                      name="apdex"
                      id="apdex"
                      shape="circle"
                      icon={<QuestionOutlined />}
                      size="small"
                      onClick={() => this.showDrawer("apdex")}
                    />
                  </label>
                  <SelectDD
                    data={apdexOptions}
                    value={this.state.apdex}
                    onSelect={apdex => this.setState({ apdex })}
                    style={{ width: "100%" }}
                  />
                </Col>
              </Row>
            </Col>
            {isDns && (
              <Col span={24}>
                <Row gutter={32}>
                  <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                    <label htmlFor="dns_query_name">DNS query value</label>
                    <Input
                      type="text"
                      id="dns_query_name"
                      name="dns_query_name"
                      placeholder="google.com"
                      value={this.state.dns_query_name}
                      onChange={this.onChange}
                    />
                  </Col>

                  <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                    <label htmlFor="dns_query_type">DNS query type</label>
                    <SelectDD
                      data={dnsQueryTypeOptions}
                      id="dns_query_type"
                      name="dns_query_type"
                      value={this.state.dns_query_type}
                      onSelect={dns_query_type => {
                        this.setState({ dns_query_type });
                      }}
                      style={{ width: "100%" }}
                    />
                  </Col>
                </Row>
              </Col>
            )}
            <Col span={24}>
              <Row gutter={32}>
                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                  <label htmlFor="probers">Probers (Datacenters)</label>
                  <SelectDD
                    id="probers"
                    name="probers"
                    mode="multiple"
                    value={this.state.probers}
                    dataObj={formatProbersOptions(this.state.proberOptions)}
                    onSelect={probers => this.setState({ probers })}
                    checkAuthority={this.checkProberSelection}
                    subscriptions={this.props.subscriptions}
                    style={{ width: "100%" }}
                    maxTagCount={3}
                  />
                </Col>
                <Col xl={12} lg={12} md={12} sm={12} xs={24}>
                  <label htmlFor="alerts">Alerts</label>
                  <SelectDD
                    id="alerts"
                    name="alerts"
                    mode="multiple"
                    value={this.state.alert}
                    dataObj={this.props.alerts}
                    onSelect={alert => this.setState({ alert })}
                    style={{ width: "100%" }}
                    maxTagCount={3}
                    extraButton="Add New Alert Channel"
                    extraButtonAction={() => this.showDrawer("alerts")}
                  />
                </Col>
              </Row>
            </Col>
            {isBaseProtocol && (
              <Col span={24}>
                <Row gutter={32}>
                  <Col xxl={12} xl={12} md={12} sm={24} xs={24}>
                    <label htmlFor="header">Header (optional)</label>
                    {this.state.http_headers &&
                      this.state.http_headers.map((el, index) => {
                        return (
                          <JsonInput
                            index={index}
                            remove={this.headerRemove}
                            headKey={Object.keys(el)[0]}
                            headValue={el[Object.keys(el)[0]]}
                            changeJsonValue={this.changeHeaderValue}
                            isLast={
                              this.state.http_headers.length - 1 === index
                            }
                            add={this.headerAdd}
                          />
                        );
                      })}
                  </Col>
                  {(this.state.http_method === "PUT" ||
                    this.state.http_method === "POST") && (
                      <Col span={12}>
                        <label htmlFor="body">Body</label>
                        <div>
                          <TextArea
                            id="body"
                            name="body"
                            value={this.state.http_body}
                            onChange={this.onBodyChange}
                            placeholder="Your request body"
                            autosize={{ minRows: 2, maxRows: 20 }}
                          />
                        </div>
                      </Col>
                    )}
                </Row>
              </Col>
            )}
            {hasGroup && (
              <Col span={24}>
                <Row>
                  <Col span={12}>
                    <label htmlFor="groups">Groups</label>
                    <Select
                      mode="tags"
                      style={{ width: "100%" }}
                      placeholder="Groups"
                      onChange={this.handleChange}
                      value={this.state.labels}
                    >
                      {this.props.labels.map(el => (
                        <Option key={el}>{el}</Option>
                      ))}
                    </Select>
                  </Col>
                </Row>
              </Col>
            )}
          </Row>
          <Col span={24}>
            <div className="check-form__btns">
              <Button
                type="button"
                shape="round"
                size="large"
                onClick={this.props.closePopUp}
              >
                Cancel
              </Button>
              <Button
                className="save"
                type="primary"
                shape="round"
                htmlType="submit"
                loading={this.props.fetchInProgress}
                size="large"
              >
                Save
              </Button>
            </div>
          </Col>
        </Form>
        {this.state.isPlansOpen && (
          <PopUp
            closePopUp={this.closePlans}
            closeOnOutClick={false}
            style={{ zIndex: 50 }}
          >
            <PlansPopUp />
          </PopUp>
        )}
        <HelpCenter
          width={isMobile ? "100%" : 475}
          placement="left"
          closable={true}
          onClose={this.onClose}
          visible={this.state.visible}
          name={this.state.componentName}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  probers: state.probers,
  monitor: state.checks.find(el => el.id === props.id),
  alerts: state.auth.alert_channels,
  labels: state.auth.labels,
  fetchInProgress: state.fetchInProgress,
  subscriptions: state.plans.subscriptions
    ? state.plans.subscriptions[0].subscription_plan.specifications
    : undefined,
  plan_name: state.plans.subscriptions
    ? state.plans.subscriptions[0].subscription_plan.name
    : undefined
});

const mapDispatchToProps = dispatch => ({
  startEditCheck: monitor => dispatch(startEditCheck(monitor)),
  startSetLabelsData: labels => dispatch(startSetLabelsData(labels))
});

export default connect(mapStateToProps, mapDispatchToProps)(EditMonitor);
